import {
	Asset,
	FONT_COLOR,
	FONT_SIZE,
	PaddedContainer,
	SPACING,
	Text,
	genClassName,
} from "@disco/disco_core";

import React from "react";

import "./lead-gen-footer.css";
import { PRIVACY_POLICY_URL } from "../../conf";
import { WIDGET_ELEMENT_CLICK_TARGET } from "../../event_conf";
import useTrack, { eventTypes } from "../../hooks/useTrack";
import windowRedirect from "../../utils/windowRedirect";
import accessibilityProvider from "../../utils/accessibilityProvider";
import useLeadGenV0Config from "../../hooks/useLeadGenV0Config";

const LeadGenFooter = ({ className = "", ...rest }) => {
	const handlePrivacyClick = () => {
		track(eventTypes.WIDGET_ELEMENT_CLICK, {
			initiatingTarget: WIDGET_ELEMENT_CLICK_TARGET.INLINE_FOOTER_PRIVACY,
		});
		windowRedirect({ url: PRIVACY_POLICY_URL });
	};

	const track = useTrack();

	const { isLargeWidget } = useLeadGenV0Config();
	const fontSize = isLargeWidget ? FONT_SIZE.BODY : FONT_SIZE.LABEL;

	return (
		<PaddedContainer
			className={genClassName({
				base: "lead-gen-footer",
				additional: className,
			})}
			flexContent
			vPadding={SPACING.TINY}
			tightBottom
			alignContentCenter
			{...rest}
		>
			<Text
				color={FONT_COLOR.MID}
				clickable
				className="lead-gen-footer-privacy"
				vPadding={2}
				tightTop
				size={fontSize}
				onClick={handlePrivacyClick}
				{...accessibilityProvider({
					role: "link",
					name: "Privacy Policy",
				})}
			>
				Privacy Policy
			</Text>
		</PaddedContainer>
	);
};
export default LeadGenFooter;
